export const PARTNER_TYPES = {
  HOTEL: 'HOTEL',
  MOTEL: 'MOTEL',
  SUPERMARKET: 'SUPERMARKET',
  PHARMACY: 'PHARMACY',
  STORE: 'STORE',
};

export const STAY_PARTNER_TYPES = [PARTNER_TYPES.HOTEL, PARTNER_TYPES.MOTEL];
export const PURCHASE_PARTNER_TYPES = [
  PARTNER_TYPES.SUPERMARKET,
  PARTNER_TYPES.PHARMACY,
  PARTNER_TYPES.STORE,
];

export const ORDER_TYPES = {
  STAY: 'STAY',
  PURCHASE: 'PURCHASE',
};

export const ORDER_STATUS = {
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
  IN_PREPARATION: 'IN_PREPARATION',
  READY: 'READY',
  OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
};

export const INVENTORY_TYPES = {
  ROOM: 'ROOM',
  PRODUCT: 'PRODUCT',
};

export const PARTNER_ACCENT_COLORS = {
  HOTEL: '#0F766E',
  MOTEL: '#9333EA',
  SUPERMARKET: '#16A34A',
  PHARMACY: '#DC2626',
  STORE: '#0EA5E9',
};

const STATUS_COLORS = {
  PENDING: '#F59E0B',
  CONFIRMED: '#0EA5E9',
  IN_PREPARATION: '#6366F1',
  READY: '#0F766E',
  OUT_FOR_DELIVERY: '#9333EA',
  COMPLETED: '#16A34A',
  CANCELLED: '#6B7280',
  REJECTED: '#DC2626',
};

export const isStayPartnerType = (partnerType) =>
  STAY_PARTNER_TYPES.includes(partnerType);

export const isPurchasePartnerType = (partnerType) =>
  PURCHASE_PARTNER_TYPES.includes(partnerType);

export const orderTypeForPartnerType = (partnerType) =>
  isStayPartnerType(partnerType) ? ORDER_TYPES.STAY : ORDER_TYPES.PURCHASE;

export const inventoryTypeForPartnerType = (partnerType) =>
  isStayPartnerType(partnerType) ? INVENTORY_TYPES.ROOM : INVENTORY_TYPES.PRODUCT;

export const isStayOrder = (order = {}) => order.orderType === ORDER_TYPES.STAY;
export const isPurchaseOrder = (order = {}) => order.orderType === ORDER_TYPES.PURCHASE;

export const accentColorForType = (partnerType) =>
  PARTNER_ACCENT_COLORS[partnerType] || '#F97316';

export const statusColor = (status) => STATUS_COLORS[status] || '#6B7280';

export const iconKeyForType = (partnerType) => {
  switch (partnerType) {
    case PARTNER_TYPES.HOTEL:
      return 'bed-double';
    case PARTNER_TYPES.MOTEL:
      return 'bed';
    case PARTNER_TYPES.SUPERMARKET:
      return 'shopping-cart';
    case PARTNER_TYPES.PHARMACY:
      return 'pill';
    case PARTNER_TYPES.STORE:
      return 'store';
    default:
      return 'sparkles';
  }
};

const startOfDay = (epoch) => {
  const d = new Date(epoch);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
};

const ONE_DAY = 24 * 60 * 60 * 1000;

export const nightsBetween = (checkIn, checkOut) => {
  const ci = startOfDay(checkIn);
  const co = startOfDay(checkOut);
  const diff = Math.round((co - ci) / ONE_DAY);
  return diff > 0 ? diff : 0;
};

export const dayKey = (epoch) => {
  const d = new Date(epoch);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}${m}${day}`;
};

export const eachDayKey = (checkIn, checkOut) => {
  const start = startOfDay(checkIn);
  const end = startOfDay(checkOut);
  const keys = [];
  for (let t = start; t < end; t += ONE_DAY) {
    keys.push(dayKey(t));
  }
  return keys;
};

export const priceWithFees = ({
  subtotal = 0,
  taxRate = 0,
  serviceFeeRate = 0,
  flatFee = 0,
  deliveryFee = 0,
  discount = 0,
}) => {
  const sub = Number(subtotal) || 0;
  const tax = sub * (Number(taxRate) || 0);
  const service = sub * (Number(serviceFeeRate) || 0);
  const flat = Number(flatFee) || 0;
  const delivery = Number(deliveryFee) || 0;
  const disc = Number(discount) || 0;
  const total = Math.max(0, sub + tax + service + flat + delivery - disc);
  return {
    subtotal: round2(sub),
    tax: round2(tax),
    serviceFee: round2(service),
    flatFee: round2(flat),
    deliveryFee: round2(delivery),
    discount: round2(disc),
    total: round2(total),
  };
};

export const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export const generateOrderReference = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let out = '';
  for (let i = 0; i < 6; i += 1) {
    out += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return out;
};

export const buildStaySnapshot = (room = {}) => ({
  id: room.id,
  name: room.name || '',
  price: Number(room.price) || 0,
  image: room.images && Object.values(room.images)[0] ? Object.values(room.images)[0] : null,
});

export const buildPurchaseItemsSnapshot = (cart = []) =>
  cart.map((line) => ({
    itemId: line.itemId || line.id,
    name: line.name,
    qty: Number(line.qty) || 1,
    price: Number(line.price) || 0,
    snapshotImage: line.image || null,
  }));
